<template>
  <div class="rank_box">
    <div class="rank_title">{{ $t("gameinfo.rank.rank_title") }}</div>
    <div class="xian"></div>
    <div class="rank rank_API">
      <div class="rank_box_title">
        <div class="rank_title_text">{{ $t("gameinfo.rank.ranklist") }}</div>
        <div class="rankadd CU" @click="showmodal">
          <img src="@/img/set_img.png" alt="" />
          <span>{{ $t("gameinfo.rank.addrank") }}</span>
        </div>
      </div>
      <div class="rank_table">
        <a-config-provider>
          <template
            v-if="datalist == '' && datalist.length <= 0"
            #renderEmpty
            style=""
          >
            <div style="text-align: center; margin-top: 100px">
              <img src="@/img/kong.png" alt="" />
              <p>{{ $t("gameinfo.rank.no_result") }}</p>
            </div>
          </template>
          <a-table
            :scroll="{ x: true }"
            :columns="columns"
            :data-source="datalist"
            :rowKey="
              (record, index) => {
                return index;
              }
            "
          >
            <template slot="id" slot-scope="text, record, index">
              {{ text }}
            </template>
            <template slot="rankName" slot-scope="text, record, index">
              {{ text }}
            </template>

            <template slot="unit" slot-scope="text, record, index">
              {{ text }}
            </template>

            <template slot="idx" slot-scope="text, record, index">
              {{ text }}
            </template>
            <template slot="type" slot-scope="text, record, index">
              {{ text }}
            </template>

            <template slot="operation" slot-scope="text, record, index">
              <span @click="alterModal(record.id)">
                <a>{{ $t("gameinfo.rank.alter") }}</a>
              </span>

              <span @click="onDeleteModel(record.id)" style="margin-left: 10px">
                <a>{{ $t("gameinfo.rank.deletes") }}</a>
              </span>
              <span style="margin-left: 10px" @click="clearrecord(record.id)">
                <a>{{ $t("gameinfo.rank.clearrecord") }}</a>
              </span>
            </template>
          </a-table>
        </a-config-provider>
      </div>
    </div>

    <!-- 这个是弹出款 -->
    <div class="modal_box" v-if="ismodal">
      <div class="modal_bg"></div>
      <div class="modal">
        <div class="modal_nav">
          <div class="modal_title" v-if="changeinfo">
            {{ $t("gameinfo.rank.updateRank") }}
          </div>
          <div class="modal_title" v-else>
            {{ $t("gameinfo.rank.addrank") }}
          </div>
          <div class="modal_url CU" @click="close">
            <img class="modal_img" src="@/img/close.png" alt="" />
          </div>
        </div>
        <div class="">
          <div class="BASIC MG_B10">
            <div class="TGA_INPUT_BOX">
              <div class="TGA_TEXT" style="line-height: 40px">
                <span class="must">*</span>
                {{ $t("gameinfo.rank.name") }}
              </div>
              <input
                type="text"
                v-model="rankinfo.rankName"
                :placeholder="$t('gameinfo.rank.nameplaceholder')"
                class="TGA_INPUT TGA_PD"
                style="width: 367px; height: 40px"
              />
              <div class="modal_text">{{ $t("gameinfo.rank.nametext") }}</div>
              <div class="init_box" style="width: 300px"></div>
            </div>
          </div>

          <div class="BASIC MG_B10">
            <div class="TGA_INPUT_BOX">
              <div class="TGA_TEXT" style="line-height: 40px">
                <span class="must">*</span>
                {{ $t("gameinfo.rank.sum") }}
              </div>
              <input
                type="text"
                v-model="rankinfo.unit"
                :placeholder="$t('gameinfo.rank.sumplaceholder')"
                class="TGA_INPUT TGA_PD"
                style="width: 367px; height: 40px"
              />
              <div class="modal_text">{{ $t("gameinfo.rank.sumtext") }}</div>
              <div class="init_box" style="width: 300px"></div>
            </div>
          </div>
          <div class="BASIC MG_B10">
            <div class="TGA_INPUT_BOX">
              <div class="TGA_TEXT" style="line-height: 40px">
                <span class="must">*</span>
                {{ $t("gameinfo.rank.maxsum") }}
              </div>
              <input
                type="number"
                v-model="rankinfo.maxPoint"
                :placeholder="$t('gameinfo.rank.maxsumplaceholder')"
                class="TGA_INPUT TGA_PD"
                style="width: 367px; height: 40px"
              />
              <div class="modal_text">{{ $t("gameinfo.rank.maxsumtext") }}</div>
              <div class="init_box" style="width: 300px"></div>
            </div>
          </div>

          <div class="BASIC">
            <div class="TGA_INPUT_BOX">
              <div class="TGA_TEXT" style="line-height: 40px">
                <span class="must">*</span>
                {{ $t("gameinfo.rank.radiotime") }}
              </div>
              <div class="radio_btn">
                <div class="CU radio_chunk" @click="selecttime(0)">
                  <img
                    class="radio_img"
                    v-if="rankinfo.type == 0"
                    src="@/img/radio.png"
                    alt=""
                  />
                  <img
                    class="radio_img"
                    v-else
                    src="@/img/no_radio.png"
                    alt=""
                  />
                  <span class="radio_text">{{
                    $t("gameinfo.rank.radioday")
                  }}</span>
                </div>
                <div class="CU radio_chunk" @click="selecttime(1)">
                  <img
                    class="radio_img"
                    v-if="rankinfo.type == 1"
                    src="@/img/radio.png"
                    alt=""
                  />
                  <img
                    class="radio_img"
                    v-else
                    src="@/img/no_radio.png"
                    alt=""
                  />
                  <span class="radio_text">{{
                    $t("gameinfo.rank.radioweek")
                  }}</span>
                </div>
                <div class="CU radio_chunk" @click="selecttime(2)">
                  <!--  v-else  -->
                  <img
                    class="radio_img"
                    v-if="rankinfo.type == 2"
                    src="@/img/radio.png"
                    alt=""
                  />
                  <img
                    class="radio_img"
                    v-else
                    src="@/img/no_radio.png"
                    alt=""
                  />
                  <span class="radio_text">{{
                    $t("gameinfo.rank.randiomonth")
                  }}</span>
                </div>
                <div class="CU radio_chunk" @click="selecttime(4)">
                  <!--  v-else  -->
                  <img
                    class="radio_img"
                    v-if="rankinfo.type == 4"
                    src="@/img/radio.png"
                    alt=""
                  />
                  <img
                    class="radio_img"
                    v-else
                    src="@/img/no_radio.png"
                    alt=""
                  />
                  <span class="radio_text">{{
                    $t("gameinfo.rank.lasting")
                  }}</span>
                </div>
              </div>
              <div class="modal_text">
                {{ $t("gameinfo.rank.radiotimetext") }}
              </div>
              <div class="modal_text_active">
                {{ $t("gameinfo.rank.radiotimeactive") }}
              </div>
            </div>
          </div>

          <div class="BASIC MG_B10">
            <div class="TGA_INPUT_BOX">
              <div class="TGA_TEXT" style="line-height: 40px">
                <span class="must">*</span>
                {{ $t("gameinfo.rank.solt") }}
              </div>
              <input
                type="number"
                v-model="rankinfo.idx"
                :placeholder="$t('gameinfo.rank.soltplaceholder')"
                class="TGA_INPUT TGA_PD"
                style="width: 367px; height: 40px"
              />
              <div class="modal_text">{{ $t("gameinfo.rank.solttext") }}</div>
              <div class="init_box" style="width: 300px"></div>
            </div>
          </div>

          <div class="BASIC">
            <div class="TGA_INPUT_BOX">
              <div class="TGA_TEXT" style="line-height: 40px">
                <span class="must">*</span>
                {{ $t("gameinfo.rank.soltradio") }}
              </div>
              <div class="radio_btn">
                <div class="CU radio_chunk" @click="selectsort(1)">
                  <img
                    class="radio_img"
                    v-if="rankinfo.sortType == 1"
                    src="@/img/radio.png"
                    alt=""
                  />
                  <img
                    class="radio_img"
                    v-else
                    src="@/img/no_radio.png"
                    alt=""
                  />
                  <span class="radio_text">{{
                    $t("gameinfo.rank.soltradioreversed")
                  }}</span>
                </div>

                <div class="CU radio_chunk" @click="selectsort(0)">
                  <img
                    class="radio_img"
                    v-if="rankinfo.sortType == 0"
                    src="@/img/radio.png"
                    alt=""
                  />
                  <img
                    class="radio_img"
                    v-else
                    src="@/img/no_radio.png"
                    alt=""
                  />
                  <span class="radio_text">{{
                    $t("gameinfo.rank.soltradiopositive")
                  }}</span>
                </div>
              </div>
              <div class="modal_text">
                {{ $t("gameinfo.rank.soltradiotext") }}
              </div>
              <div class="modal_text_active">
                {{ $t("gameinfo.rank.soltradioactive") }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal_btn CU" @click="save">
          {{ $t("gameinfo.rank.send") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      appId: this.$route.query.appId,
      gameId: this.$route.query.gameId,
      ismodal: false,
      timeradio: 0,
      sortradio: 0,
      datalist: [],
      pagination: {
        defaultCurrent: 1,
        total: 0,
        pageSize: 20, //每页中显示20条数据
      },
      columns: [
        {
          title: this.$t("gameinfo.rank.rankid"),
          dataIndex: "id",
          key: "id",
          scopedSlots: { customRender: "id" },
          width: "18%",
        },
        {
          title: this.$t("gameinfo.rank.rankName"),
          dataIndex: "rankName",
          key: "rankName",
          width: "14%",
          scopedSlots: { customRender: "rankName" },
          customRender: (text, record) => {
            var data = text;
            return text;
          },
        },
        {
          title: this.$t("gameinfo.rank.sumname"),
          dataIndex: "unit",
          key: "unit",
          width: "14%",
          scopedSlots: { customRender: "unit" },
          customRender: (text, record) => {
            var data = text;
            if (text == "null") {
              data = "无";
            }
            return data;
          },
        },
        {
          title: this.$t("gameinfo.rank.idx"),
          dataIndex: "idx",
          key: "idx",
          width: "14%",
          customRender: (text, record) => {
            var data = text;
            return data;
          },
        },
        {
          title: this.$t("gameinfo.rank.type"),
          dataIndex: "type",
          key: "type",
          width: "15%",
          customRender: (text, record) => {
            var data = text;
            if (text == 0) {
              data = this.$t("gameinfo.rank.radioday");
            } else if (text == 1) {
              data = this.$t("gameinfo.rank.radioweek");
            } else if (text == 2) {
              data = this.$t("gameinfo.rank.randiomonth");
            } else if (text == 4) {
              data = this.$t("gameinfo.rank.lasting");
            }
            return data;
          },
        },
        {
          title: this.$t("gameinfo.rank.action"),
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ],
      pageNum: 1,
      count: 10,
      // 获取排行榜编辑信息
      rankinfo: {
        id: "", //排行榜ID
        rankName: "", //排行榜名称
        unit: "", //分数单位(分数名称)
        maxPoint: "", //最大分数
        idx: "", //显示顺序
        type: 0, //刷新时间间隔
        sortType: 1, //排序规则 0-从小到大 1-从大到小
      },
      // 判断是点击添加排行榜 还是 ture 是编辑  false 是添加
      changeinfo: false,
      id: "",
    };
  },
  created() {
    this.getRankList();

    this.getGameDeveloperInfo({
      $axios: this.$axios,
      gameId: this.gameId,
    });
  },
  methods: {
    ...mapActions("game", [
      "getGameDeveloperInfo",
      "getRankConfigList",
      "getRankConfigInfo",
      "createRankConfig",
      "updateRankConfig",
      "deleteRankConfig",
      "deleteRankConfigData",
    ]),
    // 获取排行榜的列表
    async getRankList() {
      const res = await this.getRankConfigList({
        $axios: this.$axios,
        appId: this.appId,
        gameId: this.gameId,
        pageNum: this.pageNum,
        pageSize: this.count,
      });
      if (res.code == 200) {
        this.datalist = res.data;
        this.pagination.total = res.total;
      }
    },
    async save() {
      if (this.rankinfo.maxPoint == "") {
        this.$message.error(this.$t("gameinfo.rank.maxsumerror"));
        return;
      }
      if (
        this.rankinfo.rankName === "" ||
        this.rankinfo.unit === "" ||
        this.rankinfo.maxPoint === "" ||
        this.rankinfo.idx === ""
      ) {
        this.$message.error(this.$t("gameinfo.rank.error"));
        return;
      }
      if (typeof this.rankinfo.type == "string") {
        this.rankinfo.type = Number(this.rankinfo.type);
      }
      if (typeof this.rankinfo.sortType == "string") {
        this.rankinfo.sortType = Number(this.rankinfo.sortType);
      }

      if (!this.changeinfo) {
        this.addsave();
      } else {
        this.Editsave();
      }
    },

    // 保存信息
    async addsave() {
      const res = await this.createRankConfig({
        $axios: this.$axios,
        appId: this.appId,
        gameId: this.gameId,
        rankName: this.rankinfo.rankName,
        unit: this.rankinfo.unit,
        maxPoint: Number(this.rankinfo.maxPoint),
        type: Number(this.rankinfo.type),
        idx: Number(this.rankinfo.idx),
        sortType: Number(this.rankinfo.sortType),
      });
      if (res.code == 200) {
        this.$message.success(this.$t("gameinfo.rank.save_success"));
        this.ismodal = false;
        this.getRankList();
      } else {
        this.$message.error(this.$t("gameinfo.rank.save_error"));
      }
    },
    // 编辑排行榜
    async Editsave() {
      const res = await this.updateRankConfig({
        $axios: this.$axios,
        id: this.id,
        rankName: this.rankinfo.rankName,
        unit: this.rankinfo.unit,
        maxPoint: Number(this.rankinfo.maxPoint),
        idx: Number(this.rankinfo.idx),
      });
      if (res.code == 200) {
        this.$message.success(this.$t("gameinfo.rank.edit_success"));
        this.ismodal = false;
        this.getRankList();
      } else {
        this.$message.error(this.$t("gameinfo.rank.edit_error"));
      }
    },

    // 获取排行榜信息
    async alterModal(id) {
      this.changeinfo = true;
      this.ismodal = true;
      this.id = id;
      const res = await this.getRankConfigInfo({
        $axios: this.$axios,
        id: id,
      });
      if (res.code == 200) {
        this.rankinfo = res.data;
      } else {
        this.$message.error(this.$t("gameinfo.rank.system_error"));
      }
    },

    // 清除排行榜记录
    async clearrecord(id) {
      const res = await this.deleteRankConfigData({
        $axios: this.$axios,
        id: id,
      });
      if (res.code == 200) {
        this.$message.success(this.$t("gameinfo.rank.eliminate_success"));
      } else {
        this.$message.error(this.$t("gameinfo.rank.eliminate_error"));
      }
    },

    onDeleteModel(id) {
      const self = this;
      this.$confirm({
        // title: '删除',
        content: self.$t("gameinfo.rank.initmodel"),
        okText: self.$t("gameinfo.rank.ok"),
        cancelText: self.$t("gameinfo.rank.cancel"),
        onOk() {
          self.onDelete(id);
        },
      });
    },

    // 删除
    async onDelete(id) {
      const res = await this.deleteRankConfig({
        $axios: this.$axios,
        id: id,
      });
      if (res.code == 200) {
        this.$message.success(this.$t("gameinfo.rank.delete_success"));
        this.getRankList();
      } else {
        this.$message.error(this.$t("gameinfo.rank.delete_error"));
      }
    },

    // 翻页
    handleTableChange(pagination, filters, sorter) {
      this.pageNum = pagination.current;
      this.getRankList();
    },
    selectsort(index) {
      if (this.changeinfo) {
        return;
      }
      this.rankinfo.sortType = index;
    },
    // 选择 刷新时间的间隔
    selecttime(index) {
      if (this.changeinfo) {
        return;
      }
      this.rankinfo.type = index;
    },

    // 添加排行版
    showmodal() {
      this.init();
      this.ismodal = true;
      this.changeinfo = false;
    },

    // 初始化弹窗内的数据
    init() {
      this.rankinfo = {
        id: "", //排行榜ID
        rankName: "", //排行榜名称
        unit: "", //分数单位(分数名称)
        maxPoint: "", //最大分数
        idx: "", //显示顺序
        type: 0, //刷新时间间隔
        sortType: 1, //排序规则 0-从小到大 1-从大到小
      };
    },
    // 点击关闭
    close() {
      this.ismodal = false;
    },
  },
};
</script>

<style scoped="scoped">
.rank_box {
  width: 100%;
  height: 100%;
}
.rank_title {
  padding-left: 50px;
  font-size: 18px;
  color: #282828;
}
.xian {
  width: 100%;
  height: 1px;
  margin-top: 14px;
  background-color: #f3f3f3;
}
.rank {
  padding: 0 39px 0 50px;
  margin-top: 31px;
}

.rank_box_title {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
.rank_title_text {
  font-size: 14px;
  color: #666666;
  display: flex;
  align-items: center;
}
.rankadd {
  width: 133px;
  height: 40px;
  background-color: #4990fa;
  border-radius: 4px;
  color: #fff;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rankadd img {
  width: 14px;
  height: 14px;
  margin-right: 6px;
}
.rankadd span {
  line-height: 14px;
  font-size: 14px;
}
.rank_table {
  margin-top: 20px;
}
/* 下面显示弹出款 */
.modal_box {
  position: fixed;
  z-index: 100;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal_bg {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #000000;
  opacity: 0.8;
  z-index: 1;
  width: 100%;
  height: 100%;
}
.modal {
  position: relative;
  z-index: 2;
  width: 800px;
  height: 740px;
  background-color: #fff;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
.modal_nav {
  margin-bottom: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal_title {
  font-size: 14px;
  color: #282828;
  padding: 20px 0 0 20px;
}
.modal_url {
  box-sizing: border-box;
  padding: 20px 20px 0 0;
}
.modal_img {
  width: 15px;
  height: 15px;
}
.BASIC {
  display: flex;
  margin-bottom: 25px;
  padding-left: 200px;
}
.modal_text {
  width: 496px;

  font-size: 12px;
  color: #aaaaaa;
}
.modal_text_active {
  width: 496px;

  font-size: 12px;
  color: #f65651;
}
.radio_btn {
  height: 40px;
  width: 367px;
  display: flex;
  align-items: center;
}
.radio_chunk {
  display: flex;
  align-items: center;
  margin-right: 40px;
}

.radio_text {
  color: #282828;
  font-size: 14px;
  margin-left: 10px;
}
.modal_btn {
  margin: 40px auto 0;
  width: 90px;
  height: 36px;
  background-color: #4990fa;
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal .BASIC {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/games/gameinfo/Exploit_settings/rank.vue